export const buildInfo = Object.freeze({
  version: process.env.VUE_APP_BUILD_VERSION || "0.0.0",
  commit: process.env.VUE_APP_BUILD_COMMIT || "local",
});

export const buildLabel = `v${buildInfo.version} · ${buildInfo.commit}`;
